import * as React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Box, Paper, Tab, Tabs, Typography } from "@material-ui/core";
import { InTabsContext } from "./shared";

export interface CloTab {
  key: string;
  label: string;
  render: () => React.ReactNode;
}

const CloTabbedPage = ({ title, tabs }: { title: string; tabs: CloTab[] }) => {
  const history = useHistory();
  const location = useLocation();
  const requested = new URLSearchParams(location.search).get("tab");
  const current = tabs.find((t) => t.key === requested) ?? tabs[0];

  return (
    <Box p={2}>
      <Typography variant="h5" gutterBottom>
        CLO · {title}
      </Typography>
      <Paper>
        <Tabs
          value={current.key}
          onChange={(_, key) => history.replace(`${location.pathname}?tab=${key}`)}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
        >
          {tabs.map((t) => (
            <Tab key={t.key} value={t.key} label={t.label} />
          ))}
        </Tabs>
      </Paper>
      <Box mt={2} key={current.key}>
        <InTabsContext.Provider value={true}>{current.render()}</InTabsContext.Provider>
      </Box>
    </Box>
  );
};

export default CloTabbedPage;
